import { utils } from 'pixi.js';

export class DisplayUtils
{
    public static sumColors(colorA: number, colorB: number): number
    {
        const oldRgb = utils.hex2rgb(colorA);
        const newRgb = utils.hex2rgb(colorB);

        newRgb[0] = (oldRgb[0] + newRgb[0]);
        newRgb[1] = (oldRgb[1] + newRgb[1]);
        newRgb[2] = (oldRgb[2] + newRgb[2]);

        return utils.rgb2hex(newRgb);
    }

    public static mixColors(colorA: number, colorB: number, ratio = 0.5): number
    {
        const rgb1 = utils.hex2rgb(colorA);
        const rgb2 = utils.hex2rgb(colorB);
        const result = [1, 1, 1];

        const deltaR = (rgb2[0] - rgb1[0]) * ratio;
        const deltaG = (rgb2[1] - rgb1[1]) * ratio;
        const deltaB = (rgb2[2] - rgb1[2]) * ratio;

        result[0] = rgb1[0] + deltaR;
        result[1] = rgb1[1] + deltaG;
        result[2] = rgb1[2] + deltaB;

        return utils.rgb2hex(result);
    }
}
